import React from 'react';
// reactstrap components
import { Row, Col, Nav, NavItem, NavLink } from 'reactstrap';

const Footer = (props) => (
	<footer className='footer'>
		<Row className='align-items-center justify-content-xl-between'>
			<Col xl='6'>
				<div className='copyright text-center text-xl-left text-muted'>
					© 2020
					<a className='font-weight-bold ml-1' href='/#' target='_blank'>
						Mt.Dews
					</a>
				</div>
			</Col>

			<Col xl='6'>
				<Nav className='nav-footer justify-content-center justify-content-xl-end'>
					<NavItem>
						<NavLink href='/#' target='_blank'>
							Creative Tim
						</NavLink>
					</NavItem>

					<NavItem>
						<NavLink href='/#' target='_blank'>
							About Us
						</NavLink>
					</NavItem>

					<NavItem>
						<NavLink href='/#' target='_blank'>
							Developers
						</NavLink>
					</NavItem>

					<NavItem>
						<NavLink href='/#' target='_blank'>
							MIT License
						</NavLink>
					</NavItem>
				</Nav>
			</Col>
		</Row>
	</footer>
);

export default Footer;
